export const TOGGLE_SIDEBAR_OPEN = 'TOGGLE_SIDEBAR_OPEN';
export const TOGGLE_ABOUT_OPEN = 'TOGGLE_ABOUT_OPEN';
